import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GUIBaseModule } from './gui-base/gui-base.module';
import { GUIScoModule } from './gui-sco/gui-sco.module';
import { GUIDialogsModule } from './gui-dialogs/gui-dialogs.module';

@NgModule({
  imports: [
    CommonModule,
    GUIBaseModule,
    GUIScoModule,
    GUIDialogsModule,
  ],
  exports: [
    GUIBaseModule,
    GUIScoModule,
    GUIDialogsModule,
  ],
  providers: [
  ]
})
export class GUIModule { }
